import { Directive, DOCUMENT, ElementRef, inject, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '[khClickOutside]',
  standalone: false
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
  private readonly element = inject(ElementRef);
  private document = inject<Document>(DOCUMENT);

  @Input() public khClickOutside!: () => any;
  @Input() public isEventPrevented = true;

  public ngOnInit(): void {
    this.document.body.addEventListener('mousedown', this.clickHandler);
  }

  public ngOnDestroy(): void {
    this.document.body.removeEventListener('mousedown', this.clickHandler);
  }

  private clickHandler = (event: MouseEvent) => {
    if (!event.target) {
      return;
    }

    const children: HTMLElement[] = this.getChildrenOfElement(this.element?.nativeElement);
    const isClickedElementChildOfPopup = children.includes(event.target as HTMLElement);

    if (isClickedElementChildOfPopup) {
      return;
    }

    this.khClickOutside();

    if (this.isEventPrevented) {
      event.preventDefault();
    }
  };

  private getChildrenOfElement(element: HTMLElement): HTMLElement[] {
    if (!element.children) {
      return [element];
    }

    const children: any[] = [].map.call(element.children, (child: HTMLElement) => {
      const innerChildren: HTMLElement[] = !child.children.length ? [] : this.getChildrenOfElement(child);

      return [child, ...innerChildren];
    });

    return (children as HTMLElement[][]).flat(Infinity) as HTMLElement[];
  }
}
